import {Serializers} from "../../interfaces/serializer";
import {DataSource} from "../../interfaces/data-source";
import {CustomImport} from "../../interfaces/custom-import";
import {DatasetUsageComponentObjects} from '../../classes/dataset-usage-component-object';
import {CustomImportComponentObject} from "../../classes/custom-import-component-object";

export const DATA_SOURCES_CUSTOM_STATE_NAME = 'dataSourcesCustom';

export interface DataSourcesCustomState {
  serialized: Serializers<DataSource>;
  componentObjects: DatasetUsageComponentObjects;
  imports: Serializers<CustomImport>;
  customImportComponentObjects: CustomImportComponentObject[]
  importsIncluded: any;
  loading: boolean;
  loaded: boolean;
  initialized: boolean;
}
